module.exports = __webpack_public_path__ + "media/images/city/088-leaning-tower-of-pisa-476fe3f50d80b985d06a1de7eefcc498.svg";